module.exports = __webpack_public_path__ + "static/img/ecom-02.d7c16477.jpg";